import { getCompareSeries } from "../compare";
export default function seriesCompare(dataSeries) {
    //If any of the series are compare metrics use a dashed line to represent them and update the legend name.
    let isCompareMode = false;
    dataSeries.forEach((series) => {
        if (series.isCompareSeries) {
            isCompareMode = true;
            series.dashStyle = "ShortDash";
            //Update this series to have the same colour as the series with the same metric that isn't the compare date range.
            const compareSeries = getCompareSeries(dataSeries, series.metricQualified, series.name);
            if (compareSeries[0]) {
                series.color = compareSeries[0].color;
            }
        }
        //We have an exception for correlation metrics, we always show them as a spline.
        if (series.dataType === "correlation") {
            series.type = "spline";
        }
    });
    if (isCompareMode) {
        dataSeries.forEach((series) => {
            if (series.dataType === "distribution") {
                series.opacity = 0.8;
            }
            const firstPoint = {
                x: series.data[0].x - 1,
                y: null,
            };
            const lastPoint = {
                x: series.data[series.data.length - 1].x + 1,
                y: null,
            };
            series.data.unshift(firstPoint);
            series.data.push(lastPoint);
        });
    }
    return dataSeries;
}
